<template>
    <div v-if="dataLoaded">
        <ul v-if="reviews && reviews.ratings.length && reviews.status == 'ok'" :class="{'loading': loading}">
            <li v-for="(item, index) in reviews.ratings">
                <div>
                    <div class="name" v-if="item.rater != ''">
                        <i v-if="userIcon" class="fa fa-user-circle-o"></i>
                        <template v-if="item.rater.split(' ').length >= 2">{{ item.rater.split(' ')[0] | truncate(30, '...') }} {{ item.rater.split(' ')[1].slice(0,1) }}.</template>
                        <template v-else>{{ item.rater | truncate(30, '...') }}</template>
                    </div>
                    <div class="name" v-else><i v-if="userIcon" class="fa fa-user-circle-o"></i>{{ $translate("reviewWidget::Template.guest") }}</div>
                    <div class="date">
                        {{ item.date.split('-')[2] }}.{{ item.date.split('-')[1] }}.{{ item.date.split('-')[0] }}
                    </div>
                    <div class="stars">
                        <template v-for="index in item.stars * 1"><i class="fa fa-star"></i></template>
                        <template v-for="index in 5 - (item.stars * 1)"><i class="fa fa-star grey"></i></template>
                    </div>
                    <div class="comment" v-if="(limit && limitNumber) && item.comment.replaceAll('????', '').trim().split(' ').length > limitNumber">
                        <template v-for="(comment, index) in item.comment.replaceAll('????', '').trim().split(' ')" v-if="index < limitNumber">{{ comment }} </template><span class="ppp">...</span>
                        <span class="limiter">{{ $translate("reviewWidget::Template.limiter") }}</span>
                        <span class="show-more"><template v-for="(comment, index) in item.comment.replaceAll('????', '').trim().split(' ')" v-if="index >= limitNumber">{{ comment }} </template></span>
                    </div>
                    <div class="comment" v-else>
                        <template v-if="item.comment == ''">
                            {{ item.title }}
                        </template>
                        <template v-else>
                            {{ item.comment.replaceAll('????', '').trim() }}
                        </template>
                    </div>
                    <template v-for="image in variations.documents" v-if="variations.total > 0 && !noImage"">
                        <template v-if="image.id == item.relationId">
                            <div class="img" @click="directToItem('/' + image.data.texts.urlPath + '_' + image.data.item.id + '_' + image.id)">
                                <lazy-img v-if="image.data.images.variation.length > 0" :image-url="image.data.images.variation[0].urlPreview" :alt="image.data.texts.name1"></lazy-img>
                                <lazy-img v-else :image-url="image.data.images.all[0].urlPreview" :alt="image.data.texts.name1"></lazy-img>
                                <span class="date">{{ image.data.texts.name1 | truncate(60, '...') }}</span>
                            </div>
                        </template>
                    </template>
                </div>
            </li>
        </ul>

        <ol v-if="reviews && reviews.totalPages >= 2" class="pag">
            <template v-if="reviews.pageNo <= 2">
                <template v-if="reviews.pageNo == 1">
                    <li @click="loadReviews(1)" class="active">1</li>
                    <li @click="loadReviews(2)">2</li>
                    <li @click="loadReviews(3)" v-if="reviews.totalPages >= 3">3</li>
                    <li @click="loadReviews(2)"><i aria-hidden="true" class="fa fa-angle-right"></i></li>
                    <li @click="loadReviews(reviews.totalPages)"><i aria-hidden="true" class="fa fa-angle-right"></i><i aria-hidden="true" class="fa fa-angle-right"></i></li>
                </template>
                <template v-else>
                    <li @click="loadReviews(1)"><i aria-hidden="true" class="fa fa-angle-left"></i></li>
                    <li @click="loadReviews(1)">1</li>
                    <li @click="loadReviews(2)" class="active">2</li>
                    <li @click="loadReviews(3)" v-if="reviews.totalPages >= 3">3</li>
                    <li @click="loadReviews(3)" v-if="reviews.totalPages >= 3"><i aria-hidden="true" class="fa fa-angle-right"></i></li>
                    <li @click="loadReviews(reviews.totalPages)" v-if="reviews.totalPages != reviews.pageNo"><i aria-hidden="true" class="fa fa-angle-right"></i><i aria-hidden="true" class="fa fa-angle-right"></i></li>
                </template>
            </template>
            <template v-else-if="reviews.totalPages == reviews.pageNo || reviews.totalPages - 1 == reviews.pageNo">
                <template v-if="reviews.totalPages == reviews.pageNo">
                    <li @click="loadReviews(1)"><i aria-hidden="true" class="fa fa-angle-left"></i><i aria-hidden="true" class="fa fa-angle-left"></i></li>
                    <li @click="loadReviews(reviews.pageNo - 1)"><i aria-hidden="true" class="fa fa-angle-left"></i></li>
                    <li @click="loadReviews(reviews.pageNo - 2)">{{ reviews.pageNo - 2 }}</li>
                    <li @click="loadReviews(reviews.pageNo - 1)">{{ reviews.pageNo - 1 }}</li>
                    <li class="active">{{ reviews.pageNo }}</li>
                </template>
                <template v-else>
                    <li @click="loadReviews(1)"><i aria-hidden="true" class="fa fa-angle-left"></i><i aria-hidden="true" class="fa fa-angle-left"></i></li>
                    <li @click="loadReviews(reviews.pageNo - 1)"><i aria-hidden="true" class="fa fa-angle-left"></i></li>
                    <li @click="loadReviews(reviews.pageNo - 1)">{{ reviews.pageNo - 1 }}</li>
                    <li class="active">{{ reviews.pageNo }}</li>
                    <li @click="loadReviews(reviews.pageNo + 1)">{{ reviews.pageNo + 1 }}</li>
                    <li @click="loadReviews(reviews.pageNo + 1)"><i aria-hidden="true" class="fa fa-angle-right"></i></li>
                </template>
            </template>
            <template v-else>
                <li @click="loadReviews(1)"><i aria-hidden="true" class="fa fa-angle-left"></i><i aria-hidden="true" class="fa fa-angle-left"></i></li>
                <li @click="loadReviews(reviews.pageNo - 1)"><i aria-hidden="true" class="fa fa-angle-left"></i></li>
                <li @click="loadReviews(reviews.pageNo - 1)">{{ reviews.pageNo - 1 }}</li>
                <li @click="loadReviews(reviews.pageNo)" class="active">{{ reviews.pageNo }}</li>
                <li @click="loadReviews(reviews.pageNo + 1)">{{ reviews.pageNo + 1 }}</li>
                <li @click="loadReviews(reviews.pageNo + 1)"><i aria-hidden="true" class="fa fa-angle-right"></i></li>
                <li @click="loadReviews(reviews.totalPages)"><i aria-hidden="true" class="fa fa-angle-right"></i><i aria-hidden="true" class="fa fa-angle-right"></i></li>
            </template>
        </ol>

        <div v-if="reviews && reviews.ratings && reviews.totalPages >= 2" class="page">{{ $translate("reviewWidget::Template.page") }} {{ reviews.pageNo }} {{ $translate("reviewWidget::Template.of") }} {{ reviews.totalPages }}</div>
    </div>
    <div v-else>
        <ul class="pholder">
            <li v-for="n in 12">
                <div>
                    <div class="name">
                        <i v-if="userIcon" class="fa fa-user-circle-o"></i>
                        <span class="a-bg">&nbsp;&nbsp;&nbsp;</span>
                    </div>
                    <div class="date">
                        <span class="a-bg">&nbsp;</span>
                    </div>
                    <div class="stars">
                        <template v-for="n in 5"><i class="fa fa-star grey"></i></template>
                    </div>
                    <div class="comment">
                        <span class="a-bg">&nbsp;</span>
                        <span class="a-bg">&nbsp;</span>
                        <span class="a-bg">&nbsp;</span>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                reviews: {"status":"error: no ratings array!","ratings":[]},
                loading: false,
                dataLoaded: false,
                varIDs: [],
                variations: {
                    "data":{
                        "total": 0
                    }
                }
            }
        },
        props: {
            noImage: false,
            uid: String,
            userIcon: false,
            limit: false,
            limitNumber: Number
        },
        mounted() {
            // get first page

            var self = this,
            reviews = {},
            varIDs = [],
            variationString = "",
            variations = {};

            self.loading = true;

            $.getJSON('/rest/reviewWidget/feedbacks/1').done(function( data ) {
                self.reviews = data;
                self.loading = false;
                self.dataLoaded = true;

                for (var i = 0; i < self.reviews.ratings.length; i++) {
                    if (i) {
                        if (!varIDs.includes(self.reviews.ratings[i].relationId)) {
                            varIDs.push(self.reviews.ratings[i].relationId);
                        }
                        variationString += "&variationIds[]=" + self.reviews.ratings[i].relationId;
                    } else {
                        if (!varIDs.includes(self.reviews.ratings[i].relationId)) {
                            varIDs.push(self.reviews.ratings[i].relationId);
                        }
                        variationString += "variationIds[]=" + self.reviews.ratings[i].relationId;
                    }
                }

                self.varIDs = varIDs;

                $.getJSON('/rest/io/variations?' + variationString).done(function( result ) {
                    self.variations = result.data;
                })
            })
        },
        methods: {
            loadReviews(index) {
                var self = this,
                reviews = [],
                varIDs = [],
                variationString = "",
                variations = {};

                self.loading = true;

                $.getJSON('/rest/reviewWidget/feedbacks/' + index).done(function( data ) {
                    self.reviews = data;
                    self.loading = false;

                    var container = $("html,body");
                    var scrollTo = $('.widget-review-cyt.all.a-' + self.uid);

                     container.animate({
                        scrollTop: scrollTo.offset().top - container.offset().top - 200
                    }, 300);

                    for (var i = 0; i < self.reviews.ratings.length; i++) {
                        if (i) {
                            if (!varIDs.includes(self.reviews.ratings[i].relationId)) {
                                varIDs.push(self.reviews.ratings[i].relationId);
                                variationString += "&variationIds[]=" + self.reviews.ratings[i].relationId;
                            }
                        } else {
                            if (!varIDs.includes(self.reviews.ratings[i].relationId)) {
                                varIDs.push(self.reviews.ratings[i].relationId);
                                variationString += "variationIds[]=" + self.reviews.ratings[i].relationId;
                            }
                        }
                    }

                    self.varIDs = varIDs;

                    $.getJSON('/rest/io/variations?' + variationString).done(function( result ) {
                        self.variations = result.data;
                    })
                })
            },
            directToItem: function(url) {
                window.location.href = url;
            }
        }
    }
</script>
